/*
  Where RingCentral returns the browser after a user signs in (story 15619). The backend builds the
  same URL (FE_DOMAIN + this path, RingCentralConnectionService.CallbackPath), and each environment's
  must be registered on the RingCentral app.

  The sign-in runs in a popup so the compose window behind it keeps what was typed. The popup comes
  back here, src/index.tsx renders RingCentralCallback instead of the app (no router, no MSAL - an
  expired login would otherwise send the popup off to Microsoft holding RingCentral's single-use
  code), and it hands the code to the window that opened it over a BroadcastChannel. Not
  window.opener: a sign-in page that sets Cross-Origin-Opener-Policy severs that link, and the
  channel only needs the same origin.
*/
export const RINGCENTRAL_CALLBACK_PATH = '/ringcentral/callback';

export const RINGCENTRAL_CALLBACK_CHANNEL = 'compass-ringcentral-connect';

export type RingCentralCallbackMessage = {
  code: string | null;
  state: string | null;
  error: string | null;
};
